import { render, staticRenderFns } from "./PublicationDetail.vue?vue&type=template&id=40e3f610&scoped=true&"
import script from "./PublicationDetail.vue?vue&type=script&lang=js&"
export * from "./PublicationDetail.vue?vue&type=script&lang=js&"
import style0 from "./PublicationDetail.vue?vue&type=style&index=0&id=40e3f610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3f610",
  null
  
)

export default component.exports